module.exports = __webpack_public_path__ + "static/media/AYS_PROFILE.07df755b.png";